import { FC } from 'react';
import { ArrowBack, Close } from '@mui/icons-material';
import { Button as LinkButton } from '../../../components';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Modal } from '../../../components';
import { Box, Typography, Button, ButtonGroup, Fade } from '@mui/material';

interface IPandaDocInfoModal {
  open: boolean;
  onClose: () => void;
  buildId: string | number;
  isError: boolean;
  errorMessage: string;
}

export const PandaDocInfoModal: FC<IPandaDocInfoModal> = ({
  open,
  onClose,
  buildId,
  isError,
  errorMessage
}) => {
  const classes = useStyles();

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title={isError ? 'Error' : 'Success'} maxWidth="xs">
      <Fade in={open}>
        <Box mt={0.5}>
          {isError ? (
            <>
              <Typography paddingBottom={2}>
                There was an error sending your file for signatures, see resolution options below:
              </Typography>
              <Typography className={classes.errorMessage}>{errorMessage}</Typography>
            </>
          ) : (
            <Typography gutterBottom>
              The contract has successfully sent for signatures. After all parties sign, the Build
              will be updated accordingly.
            </Typography>
          )}
          <ButtonGroup sx={{ gap: '10px', paddingTop: '20px' }}>
            <LinkButton
              id="back-to-selection-details"
              startIcon={<ArrowBack />}
              variant="contained"
              color="primary"
              asLink
              to={{
                pathname: `/sales/contracting/build-options/${buildId}`,
                state: { showSelectionDetails: true }
              }}
            >
              Back to Selections
            </LinkButton>
            <Button startIcon={<Close />} variant="contained" color="inherit" onClick={handleClose}>
              Close
            </Button>
          </ButtonGroup>
        </Box>
      </Fade>
    </Modal>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  errorMessage: {
    color: theme.palette.error.main,
    paddingBottom: theme.spacing(2)
  }
}));
